// Auto-extracted from SellerAnalytics.jsx
import { useState } from "react";
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Icon } from "../../components/Icon";
import { fmtK, fmtKShort } from "../../lib/money";
import { resolveImage } from "../../lib/images";
import { STATUS_TONES } from "./constants";

export function MetricRow({ icon, title, value, status, recommendation, benchmarks }) {
  const [open, setOpen] = useState(false);
  const tone = STATUS_TONES[status] || STATUS_TONES.good;
  return (
    <Card pad={0}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          padding: "14px 18px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontFamily: "inherit",
          textAlign: "left",
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: C.cream,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon name={icon} size={16} color={C.hunter} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, color: C.muted, fontWeight: 700 }}>{title}</div>
          <div style={{ fontSize: 18, fontWeight: 900, color: C.charcoal, letterSpacing: "-0.3px" }}>{value}</div>
        </div>
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 800,
            padding: "4px 9px",
            borderRadius: 7,
            background: tone.bg,
            color: tone.fg,
            textTransform: "uppercase",
            letterSpacing: 1,
            whiteSpace: "nowrap",
          }}
        >
          {tone.label}
        </span>
        <Icon name={open ? "chevron-up" : "chevron-down"} size={16} color={C.muted} />
      </button>
      {open && (
        <div style={{ padding: "0 18px 16px", borderTop: `1px solid ${C.cream}` }}>
          <div style={{ paddingTop: 14, fontSize: 13, color: C.slate, lineHeight: 1.5 }}>
            {recommendation}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 8,
              marginTop: 12,
            }}
          >
            {benchmarks.map((b, i) => (
              <div
                key={i}
                style={{
                  padding: "10px 12px",
                  borderRadius: 10,
                  background: C.cream,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 800,
                    color: C.muted,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  {b.label}
                </div>
                <div style={{ fontSize: 13, fontWeight: 800, color: C.charcoal, marginTop: 2 }}>{b.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
